import { render } from "./Dialpad.vue?vue&type=template&id=12bdf93c"
import script from "./Dialpad.vue?vue&type=script&lang=js"
export * from "./Dialpad.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__